import { HeadCell } from '../../../../ui-kit';
import { translate } from '../../../../utils';
import { DeductionListItem } from './types';

export const deductionListItemsHeadCells: HeadCell<DeductionListItem>[] = [
    { id: 'stockCard', label: translate('Warehouse card') },
    { id: 'quantity', label: translate('Deducted quantity'), align: 'right' },
    { id: 'unitType', label: translate('Unit type'), align: 'right' },
    { id: 'priceWithoutVat', label: translate('Deducted item value'), align: 'right' },
];
